import { Component, OnInit } from '@angular/core';

import { PageInfoService } from '../../layouts/page-info.service';
import { NavSectionEnum } from '../../layouts/nav-section.enum';

/**
 * This component serves as the "home page" in the application.
 */
@Component({
	selector: 'cc-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

// #region [ Constructor ]

	constructor(
		private _PageInfoService: PageInfoService
	) { }

// #region [ Event Handlers ]

	/**
	 * Component initialization.
	 */
	public ngOnInit(): void {
		this._PageInfoService.PageTitle = "Home";
		this._PageInfoService.PageDescription = "Welcome to Crown Connect!";
		this._PageInfoService.CurrentSection = NavSectionEnum.Home;
	}

}